






























import { defineComponent, ref, reactive } from '@vue/composition-api';
import { useMutation } from '@vue/apollo-composable';
import CommonConfirmDialog from '@/components/Dialog/CommonConfirmDialog.vue';
import CommonCheckButton from '@/components/CommonCustomButton/CommonCheckButton.vue';
import cdn from '@/cdn';
import deleteDocument from '@/gql/deleteDocument.gql';
import updateDocument from '@/gql/updateDocument.gql';
import document from '@/table/document';

const CommonFileTable = defineComponent({
  setup(props: any, context: any) {
    function viewFile(item: any) {
      window.open(cdn.access(item.item.folder, item.item.filename), '_blank');
    }

    const editVariable = reactive({
      item: {
        id: '', active: '', fileType: '', filename: '', uploadedBy: {},
      },
    });

    const updateFileMutation = useMutation(
      updateDocument,
      () => ({
        variables: {
          id: editVariable.item?.id,
          isActive: !(editVariable.item?.active),
        },
        optimisticResponse: {
          __typename: 'Mutation',
          updateDocument: {
            __typename: 'Document',
            ...editVariable.item,
            active: !editVariable.item?.active,
            updatedAt: new Date(),
            uploadedBy: {
              ...editVariable.item?.uploadedBy,
              updatedAt: new Date(),
            },
          },
        },
      }),
    );

    function updateFile(item: any) {
      editVariable.item = { ...item };
      updateFileMutation.mutate();
      const _value = props.value.map((element: any) => {
        if (element.id === editVariable.item.id) {
          return {
            ...element,
            active: !(editVariable.item.active),
          };
        }
        return element;
      });
      context.emit('input', _value);
    }

    const removedDocumentId = ref('');
    const removeDocumentMutation = useMutation(deleteDocument,
      () => ({
        variables: {
          id: removedDocumentId.value,
        },
      }));
    function onRemoveDocument() {
      const _value = props.value.filter((item: any) => item.id !== removedDocumentId.value);
      context.emit('input', _value);
    }

    return {
      viewFile,
      document,
      onRemoveDocument,
      removedDocumentId,
      removeDocumentMutation,
      updateFile,
    };
  },
  props: {
    value: {
      type: Array,
      default() { return []; },
    },
  },
  components: {
    CommonConfirmDialog,
    CommonCheckButton,
  },
});

export default CommonFileTable;
